import Header from '../Navigation/Header'
import Footer from '../Navigation/Footer'
import { ClientsBanner } from '../../components/ClientsBanner'
import { Seo } from '../../helpers/Seo'
import { Link } from 'react-router-dom'
import { Icon } from '@iconify/react'
import { Accordion } from '../../components/Accordion'

export default function EmergencyLoan() {
    return (
        <div>
            <Seo
                title="Prêt urgent rapide​ | Trouvez les meilleures offres | Argent Aujourd’hui"
                description="Comparez les prêts urgent rapide en ligne sur notre site et choisissez l'option idéale pour vos besoins. Accédez aux meilleures offres dès maintenant."
                type="webapp"
                name="Argent Aujourd'hui"
            />
            <Header />

            <section className="header">
                <div data-aos="fade-up">
                    <h1 className="header-title">Prêt urgent rapide</h1>

                    <p className="header-subtitle">
                        Vous cherchez une solution de financement pour répondre à un besoin
                        immédiat? Comparez les options à votre disposition pour obtenir un prêt
                        urgent et rapide au Québec avec Argent Aujourd’hui!
                    </p>

                    <Link to="/new-lead" className="btn">
                        Demander un prêt
                    </Link>
                </div>
            </section>

            <section className="Situation-steps">
                <div className="content" data-aos="fade-up">
                    <h2 className="sect-title">Obtenir un prêt d’urgence en 3 étapes simples</h2>

                    <p className="sect-subtitle">
                        Un besoin d’argent urgent peut se manifester à tout moment dans la vie. Que
                        vous ayez une dépense imprévue à faire sur votre véhicule, une réparation
                        urgente à faire ou une facture qui dépasse votre budget, nos prêts rapides
                        vous offrent une solution immédiate! Voici les étapes à suivre pour obtenir
                        un prêt personnalisé avec Argent Aujourd’hui.
                    </p>

                    <ol style={{ marginTop: 50 }}>
                        <li>
                            <div className="icon">
                                <Icon icon="simple-line-icons:note" width="40" />
                            </div>
                            <h3>Explorez vos options de financement</h3>
                            <p>
                                Commencez par remplir notre formulaire de demande en nous
                                renseignant vos coordonnées et le montant que vous aimeriez obtenir.
                                Nous vous proposerons ensuite les solutions de prêts urgents et
                                rapides au Québec qui pourraient répondre à vos besoins.
                            </p>
                        </li>
                        <li>
                            <div className="icon">
                                <Icon icon="simple-line-icons:home" width="40" />
                            </div>
                            <h3>Choisissez une institution</h3>
                            <p>
                                Pour chaque option de financement, comparez le montant, le délai de
                                remboursement et le prix du prêt. Une fois que vous avez choisi
                                votre institution, cliquez simplement sur son nom et vous serez
                                directement redirigé vers leur formulaire de demande.
                            </p>
                        </li>
                        <li>
                            <div className="icon">
                                <Icon icon="simple-line-icons:paper-plane" width="40" />
                            </div>
                            <h3>Faites votre demande de prêt rapide en ligne</h3>
                            <p>
                                Vous en avez besoin le plus rapidement possible? Une fois que vous
                                aurez obtenu l’approbation de votre demande, vous pourrez obtenir le
                                paiement sur votre compte bancaire dans les 24 heures qui suivent!
                            </p>
                        </li>
                    </ol>
                </div>
            </section>

            <section className="sect sect-bg-light">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Les avantages de nos prêts</h2>

                    <p className="sect-subtitle">
                        Pour vous aider à trouver la meilleure option de financement, Argent
                        Aujourd’hui compare pour vous les différentes institutions de prêts
                        personnels qui pourraient répondre à votre besoin. Évitez des heures de
                        recherche et de comparaison, nous nous en occupons pour vous! En utilisant
                        notre comparateur de prêts urgents et rapides, vous bénéficiez d’une
                        multitude d’avantages :
                    </p>

                    <ul className="styled-checklist" style={{ marginTop: 30 }}>
                        <li style={{ marginBottom: 30 }}>
                            <h4>Démarche gratuite et sans engagement</h4>

                            <span style={{ marginTop: 130 }}>
                                Découvrez des options personnalisées en quelques clics et choisissez
                                votre institution à votre rythme.
                            </span>
                        </li>
                        <li style={{ marginBottom: 30 }}>
                            <h4>Prêt sans enquête de crédit</h4>

                            <span style={{ marginTop: 130 }}>
                                Vous avez besoin d'argent tout de suite sans enquête de crédit? Pour
                                vérifier votre capacité de remboursement, nos partenaires effectuent
                                des vérifications bancaires instantanées (prêt IBV). Cette démarche
                                permet d’obtenir un prêt sans affecter votre cote de crédit!
                            </span>
                        </li>
                        <li style={{ marginBottom: 30 }}>
                            <h4>Institutions vérifiées</h4>

                            <span style={{ marginTop: 130 }}>
                                Nous travaillons uniquement avec des prêteurs enregistrés au{' '}
                                <a
                                    href={
                                        'https://www.quebec.ca/entreprises-et-travailleurs-autonomes/obtenir-renseignements-entreprise/recherche-registre-entreprises'
                                    }
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Registre des entreprises du Québec
                                </a>{' '}
                                qui possèdent les permis et accréditations demandés par l’Office de
                                protection des consommateurs.
                            </span>
                        </li>
                        <li style={{ marginBottom: 30 }}>
                            <h4>Prêt virement interac</h4>

                            <span style={{ marginTop: 130 }}>
                                Notre démarche est entièrement en ligne et vous permet de revoir
                                l’argent directement sur votre compte bancaire, dans un délai de 24
                                heures.
                            </span>
                        </li>
                    </ul>
                </div>
            </section>

            <section className="sect sect-bg-dark">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">
                        Un prêt d’urgence pour vous aider en cas d’imprévu
                    </h2>

                    <p className="sect-subtitle">
                        Personne n’est à l’abri d’une urgence financière. Quelle que soit la
                        situation à laquelle vous faites face, il existe des solutions rapides pour
                        répondre à votre besoin d’argent. Nous n’avons pas besoin de votre
                        historique ou de la raison de votre emprunt, nous regardons vers l’avenir,
                        pas le passé! En quelques étapes simples, vous pouvez obtenir un prêt sans
                        justificatif de salaire entre 100 $ et 1500 $.
                    </p>
                </div>
            </section>

            <section className="sect sect-bg-light">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">
                        Choisissez le montant pour votre besoin d’argent urgent
                    </h2>

                    <p className="sect-subtitle">
                        Des petits montants aux plus grands, profitez de prêts sans refus pour
                        obtenir une avance de fond rapidement!
                    </p>

                    <div className="loan-options">
                        <ul>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 100$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 200$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 300$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 500$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 700$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 1 000$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 1 500$</li>
                            </Link>
                        </ul>
                    </div>
                </div>
            </section>

            <section className="sect sect-bg-dark">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">
                        Questions fréquemment posées sur les prêts urgents
                    </h2>

                    <div style={{ marginTop: 50 }}>
                        <Accordion
                            items={[
                                {
                                    title: "Existe-t-il des prêts d'urgence?",
                                    content: (
                                        <p>
                                            Oui! Argent Aujourd'hui est spécialisé dans la recherche
                                            de prêts d'urgence rapides et fiables pour répondre à
                                            des besoins financiers urgents.
                                        </p>
                                    ),
                                },
                                {
                                    title: 'Comment emprunter de l’argent rapidement en cas d’urgence?',
                                    content: (
                                        <p>
                                            En utilisant les services d’Argent Aujourd’hui, vous
                                            pouvez comparer les institutions de prêts et obtenir un
                                            prêt instantané adapté à vos besoins.{' '}
                                            <Link to="/new-lead">
                                                Remplissez notre formulaire en ligne
                                            </Link>{' '}
                                            pour connaître vos options et recevoir des fonds sur
                                            votre compte dans les 24 heures.
                                        </p>
                                    ),
                                },
                                {
                                    title: "Comment obtenir de l'argent immédiatement en cas d'urgence?",
                                    content: (
                                        <p>
                                            Commencez par{' '}
                                            <Link to="/new-lead">
                                                remplir la demande de prêt en ligne
                                            </Link>
                                            . Choisissez votre prêteur, fournissez les documents
                                            requis et recevez votre prêt d'urgence par virement
                                            interac.
                                        </p>
                                    ),
                                },
                            ]}
                        />
                    </div>
                </div>
            </section>

            <section className="Eligible sect-bg-light">
                <div className="card" data-aos="fade-up">
                    <div className="content">
                        <div className="section-title">
                            <h2>Êtes-vous éligible?</h2>
                        </div>
                        <p>
                            Quelle que soit votre situation financière actuelle, il est possible
                            d’obtenir un prêt urgent et rapide! Les seuls critères auxquels vous
                            devez répondre sont les suivants :
                        </p>
                        <ul>
                            <li>Avoir au moins 18 ans</li>
                            <li>Résider au Québec</li>
                            <li>Avoir un revenu stable</li>
                            <li>Ne pas avoir d’opposition de paiement</li>
                            <li>
                                Avoir le moins de frais de fonds non suffisants possible (frais NSF)
                            </li>
                        </ul>
                        <p>
                            Nous offrons également des prêts sans emploi ou des prêts en cas de
                            mauvais crédit. Explorez nos options pour trouver la solution de
                            financement qui vous convient.
                        </p>
                        <Link to="/new-lead" className="btn">
                            Demander un prêt
                        </Link>
                    </div>
                </div>
            </section>

            <ClientsBanner />

            <Footer />
        </div>
    )
}
